import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import ChatWithArtifacts from '../components/chat/ChatWithArtifacts';
import { globalChatState } from '../contexts/ChatStateProvider';
import { chatService } from '../services/api';

function Chat() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [currentSessionId, setCurrentSessionId] = useState(null);
  const [checkpointContext, setCheckpointContext] = useState(null);

  useEffect(() => {
    const sessionId = searchParams.get('session');
    const checkSession = () => {
      const state = globalChatState.getSnapshot();
      const activeSessionId = state.currentSessionId || sessionId;
      setCurrentSessionId(activeSessionId);
      
      // Sync URL if no session param but we have an active session
      if (!sessionId && state.currentSessionId) {
        console.log('[DEBUG-CHAT] 🔗 Syncing URL with active session:', state.currentSessionId);
        navigate(`/chat?session=${state.currentSessionId}`, { replace: true });
      }
    };

    checkSession();
    const unsubscribe = globalChatState.subscribe(checkSession);
    return unsubscribe;
  }, [searchParams, navigate]);

  // If we have a session ID from URL but not in global state, switch to it
  useEffect(() => {
    const sessionId = searchParams.get('session');
    if (sessionId && sessionId !== globalChatState.getSnapshot().currentSessionId) {
      globalChatState.switchSession(sessionId);
    }
  }, [searchParams]);

  // Check for checkpoint editing context
  useEffect(() => {
    const fixCheckpoint = searchParams.get('fix_checkpoint');
    const experimentId = searchParams.get('experiment_id');
    const phaseName = searchParams.get('phase_name');

    if (fixCheckpoint && experimentId) {
      setCheckpointContext({
        phase: fixCheckpoint,
        experimentId: experimentId,
        phaseName: phaseName || fixCheckpoint,
      });
    }
  }, [searchParams]);

  // Clear active session when component unmounts
  useEffect(() => {
    return () => {
      chatService.setActiveSession(null);
    };
  }, []);

  return (
    <div className="h-full">
      <ChatWithArtifacts
        sessionId={currentSessionId}
        checkpointContext={checkpointContext}
      />
    </div>
  );
}

export default Chat;